module.exports = __webpack_public_path__ + "img/4-min.4cb8cb60.jpg";